module.exports = __webpack_public_path__ + "static/Jojo-c46f6621839f3b43d9d2448a2b9c4ea3.png";